import { useEffect, useState } from "react";
import RadioGroup from "../../components/Form/RadioGroup";
import Search from "../../components/Form/Search";
import Button from "../../components/Form/Button";
import Modal from "../../components/Elements/Modal";
import FaqCategoryItem from "../../components/Items/FaqCategoryItem";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  detailsFaqCategories,
  listFaqCategories,
  ordering,
} from "../../helpers/api_helper";
import moment from "moment";
import AddFaqCategory from "../../components/Modals/AddFaqCategory";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Pagination from "../../components/Elements/Pagination";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { Loading } from "../../components/Elements/Loading";
import { Error } from "../../components/Elements/Error";
import { NoData } from "../../components/Elements/NoData";
const FaqCategory = () => {
  const queryClient = useQueryClient();
  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);
  // For Filtering Data 🔍
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState("");

  // for ordering
  const [isOne, setDataOne] = useState(false);
  const [dataList, setDataList] = useState([]);

  // To fetch Details of specific items when it needs to be edited
  const [editId, setEditId] = useState("");

  // Dynamic query key for FaqCategories 🗝️
  const queryFaqcategories = ["Faqcategories", keyword, status, limit, offset];
  const [perPages] = useState([
    { label: "10 (Default)", value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: "All", value: 999999 },
  ]);
  // Static status Radio buttons
  const [statusStatic, setStatusStatic] = useState([
    { _id: "", name: "All", color: "success", current: true },
    { _id: true, name: "Published", color: "success", current: false },
    { _id: false, name: "Draft", color: "warning", current: false },
  ]);

  // For opening Add Modal althogh not mandetory
  const addModal = () => {
    setIsAddModal(true);
  };

  // For fetching details of item
  const {
    data: details,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["details", editId],
    queryFn: async () => detailsFaqCategories({ id: editId }),
    enabled: false,
  });

  // Refetch when editId updates
  useEffect(() => {
    if (editId !== "" && isEditModal) {
      refetch();
    }
  }, [editId, refetch, isEditModal]);

  // FaqCategories List Component
  function FaqCategoryList() {
    // Custom hook for fetching FaqCategories list
    function useFaqCategory() {
      return useQuery({
        queryKey: queryFaqcategories,
        queryFn: () =>
          listFaqCategories({
            keyword: keyword,
            category_type: "faqs",
            sortByField: "ordering",
            sortByValue: 1,
            status: status,
            limit: limit,
            offset: offset,
          }),
        keepPreviousData: true,
      });
    }

    const { data: Faqcategories, error, isFetching } = useFaqCategory();

    useEffect(() => {
      if (!isOne) {
        setDataList(Faqcategories?.data);
      }
    }, [isOne, Faqcategories?.data]);

    const handleDragEnd = (e) => {
      setDataOne(true);
      if (!e.destination) return;
      let tempData = Array.from(dataList);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);
      // console.log(tempData);

      let dataArray = [];
      for (let i = 0; i < tempData.length; i++) {
        dataArray.push({ id: tempData[i]._id, ordering: i + 1 });
      }
      // setOrderingData(dataArray);

      onClickSaveOrdering(dataArray, tempData);
      setDataList(tempData);
    };
    const onClickSaveOrdering = async (orderingData) => {
      const saveOrdering = await ordering({
        orderingData: orderingData,
        tableName: "category",
      });

      if (saveOrdering.status === 200) {
        setDataOne(false);
        queryClient.invalidateQueries(queryFaqcategories);
        queryClient.removeQueries({
          queryKey: ["Faqcategories"],
          type: "inactive",
        });

        queryClient.removeQueries({
          queryKey: ["feedback_categories_dropdown"],
          type: "inactive",
        });

        toast.success(saveOrdering.message);
      } else {
        toast.error(saveOrdering.message);
      }
    };

    // Handling loading state 😑
    if (isFetching) {
      return <Loading />;
    }

    // Handling error state 🥴
    if (error) {
      return <Error />;
    }

    // Check if their is no data 🤨
    else if (Faqcategories.data.length === 0) {
      return <NoData />;
    }

    // Renders the list
    else {
      return (
        // For Pagination
        <>
          {/* {Faqcategories.data.map((item) => ( */}
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId={"div"}>
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {!isOne &&
                    dataList &&
                    dataList.length > 0 &&
                    dataList.map((item, index) => (
                      <FaqCategoryItem
                        key={item?._id}
                        FaqcategoriesId={item._id}
                        index={index}
                        image={item?.image}
                        name={item?.name}
                        descriptions={item?.description}
                        createdDate={moment(new Date(item?.created_at)).format(
                          "Do MMM YY"
                        )}
                        updatedDate={moment(new Date(item?.updated_at)).format(
                          "Do MMM YY"
                        )}
                        query={queryFaqcategories}
                        status={item?.status}
                        setEditId={setEditId}
                        detailsFetch={refetch}
                        setEditModal={setIsEditModal}
                      />
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Pagination
            count={Faqcategories.count}
            limit={limit}
            offset={offset}
            setOffset={setOffset}
          />
        </>
      );
    }
  }

  return (
    <>
      <div className="page-filter mb-3">
        <div className="input-filters">
          <div className="input-items">
            {perPages && (
              <div className="input">
                <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={perPages}
                  value={selectedPageOpt || []}
                  placeholder={"Per Page"}
                  onChange={(e) => {
                    setLimit(e.value);
                    setSelectedPageOpt(e);
                  }}
                />
              </div>
            )}
          </div>
          <div className="input-items">
            <Search
              state={keyword}
              setState={setKeyword}
              placeholder={"Search..."}
            />
          </div>

          <div className="input-items items-end ms-auto gap-3">
            <Button
              classes={"px-2"}
              icon={"fa-regular fa-arrow-rotate-right"}
              iconPosition={"left"}
              functions={() => {
                queryClient.invalidateQueries(queryFaqcategories);
                queryClient.removeQueries({
                  queryKey: ["Faqcategories"],
                  type: "inactive",
                });
                queryClient.removeQueries({
                  queryKey: ["feedback_categories_dropdown"],
                  type: "inactive",
                });
                setOffset(0);
                setKeyword("");
                setStatus("");
                setLimit(10);
                setSelectedPageOpt([]);
                setStatusStatic([]);
                setTimeout(() => {
                  setStatusStatic([
                    { _id: "", name: "All", color: "success", current: true },
                    {
                      _id: true,
                      name: "Published",
                      color: "success",
                      current: false,
                    },
                    {
                      _id: false,
                      name: "Draft",
                      color: "warning",
                      current: false,
                    },
                  ]);
                }, 300);
              }}
            />
            <Button
              label={"Add"}
              labelClasses={""}
              classes={""}
              icon={"fa-regular fa-plus"}
              iconPosition={"left"}
              functions={addModal}
            />
          </div>
        </div>
        <div className="radio-filters">
          <RadioGroup
            data={statusStatic}
            setData={setStatus}
            inputName={"status"}
          />
        </div>
      </div>
      <div className="faqs-list">
        <FaqCategoryList />
      </div>
      {/* for adding modal */}
      <Modal
        title={"Add FAQ Category"}
        size={"md"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(!isAddModal)}
      >
        <AddFaqCategory modalClose={() => setIsAddModal(false)} query={queryFaqcategories} />
      </Modal>
      {/* //For Edit Modal */}
      <Modal
        title={"Edit FAQ Category"}
        size={"md"}
        isOpen={isEditModal}
        modalClose={() => setIsEditModal(false)}
      >
        <AddFaqCategory
          modalClose={() => setIsEditModal(false)}
          query={queryFaqcategories}
          details={details}
          isFetching={isFetching}
        />
      </Modal>
    </>
  );
};

export default FaqCategory;
